/**
 * Species hero art (AI-generated, one consistent golden-hour savanna style;
 * provenance logged in src/ui/assets/PROVENANCE.md). Files live in
 * public/art/species/<id>.png. Unknown species fall back to the icon.
 */
const ALIASES: Record<string, string> = {
  chital: 'axis_deer',
};

export function speciesArtUrl(species: string): string {
  const id = species.trim().toLowerCase().replace(/[\s-]+/g, '_');
  return `/art/species/${ALIASES[id] ?? id}.jpg`;
}
